import type { ReactNode } from 'react';

export function ErrorState({
  message,
  action,
}: {
  message: string;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="notice notice--error" role="alert">
      <p className="mt-0">{message}</p>
      {action}
    </div>
  );
}
